import { createContext, useContext } from "react";

export interface MonthOptionsContextType {
  optionsData: OptionItem[];
  monthYearList: string[];
  selectedYearMonth: string | null;
  setSelectedYearMonth: (value: string) => void;
  selectedPYYear: string | null;
  selectedPYYearMonth: (value: string) => void;
  isLoading: boolean;
  isError: boolean;
  refetchOptions: () => void;
}

export const MonthOptionsContext = createContext<MonthOptionsContextType | undefined>(undefined);

export const useMonthOptions = (): MonthOptionsContextType => {
  const context = useContext(MonthOptionsContext);
  if (!context) {
    throw new Error("useMonthOptions must be used within a MonthOptionProvider");
  }
  return context;
};
